<template>
  <div class="topup-modal">
    <div class="topup-modal-content">
      <main v-if="isStatusAmountTooLow">
        <p><strong>Zbyt niska wartość doładowania!</strong></p>
        <p v-if="recalculatedAmount">Minimalna kwota to: {{ recalculatedAmount | pln }} zł.</p>
      </main>
      <main v-if="isStatusOperatorError">
        <p><strong>Błąd dostępu do systemu operatora.</strong></p>
        <p>Prosimy spróbować za chwilę.</p>
      </main>
      <main v-if="isStatusCodeError">
        <p><strong>Niepoprawny kod licznika!</strong></p>
        <p>Podaj prawidłowy kod swojego licznika energii.</p>
      </main>
      <main v-if="isStatusTopupBlocked">
        <p><strong>Blokada możliwości doładowania.</strong></p>
        <p>Prosimy o kontakt z Biurem Obsługi Klienta.</p>
      </main>
      <main v-if="isStatusOther">
        <p><strong>Błąd doładowania!</strong></p>
        <p>Spróbuj ponownie.</p>
      </main>
      <footer>
        <button type="button" class="btn" @click="close">OK</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { ENERGY_CALCULATION_STATUS, ENERGY_CALCULATION_STATUS_LIST } from '@/common/const/energy.const'

const ERROR_CODES = [
  ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.operatorError],
  ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.amountTooLow],
  ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.codeError],
  ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.topupBlocked]
]

export default {
  name: 'TopupEnergyModal',
  computed: {
    ...mapState({
      amount: state => state.energy.formData.amount,
      recalculatedAmount: state => state.energy.recalculatedAmount,
      isStatusOperatorError: state => state.energy.calculationStatus === ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.operatorError],
      isStatusAmountTooLow: state => state.energy.calculationStatus === ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.amountTooLow],
      isStatusCodeError: state => state.energy.calculationStatus === ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.codeError],
      isStatusTopupBlocked: state => state.energy.calculationStatus === ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.topupBlocked],
      isStatusOther: state => state.energy.calculationStatus !== ENERGY_CALCULATION_STATUS_LIST[ENERGY_CALCULATION_STATUS.ok] && !ERROR_CODES.includes(state.energy.calculationStatus)
    })
  },
  methods: {
    ...mapMutations([
      'SET_ENERGY_MODAL_VISIBLE'
    ]),
    close: function () {
      this.SET_ENERGY_MODAL_VISIBLE(false)
    }
  }
}
</script>
